import React from 'react'
import { Col, Nav, Row, Tab } from 'react-bootstrap'
import Yesterday from '@components/pages/Dashboard/MorningHuddle/Yesterday.component'
import Today from '@components/pages/Dashboard/MorningHuddle/Today.component'
import Tomorrow from '@components/pages/Dashboard/MorningHuddle/Tomorrow.component'
import MotivationalMinute from '@components/pages/Dashboard/MorningHuddle/MotivationalMinute'

import '../../components/pages/Dashboard/DashboardStyle.css'

function MorningHuddle(): React.ReactElement {
  return (
    <Row className="mt-2 mb-2 chart-tab morning-huddle">
      <Col md={12}>
        <Tab.Container defaultActiveKey={'Yesterday'}>
          <Col md={12} className="p-0">
            <Nav variant="pills" className="chart-tab">
              <Nav.Item key={``} className="">
                <Nav.Link eventKey={'Yesterday'}>{'Yesterday'}</Nav.Link>
              </Nav.Item>
              <Nav.Item key={``} className="">
                <Nav.Link eventKey={'Today'}>{'Today'}</Nav.Link>
              </Nav.Item>
              <Nav.Item key={``} className="">
                <Nav.Link eventKey={'Tomorrow'}>{'Tomorrow'}</Nav.Link>
              </Nav.Item>
              <Nav.Item key={``} className="">
                <Nav.Link eventKey={'Motivational-Minute'}>
                  {'Motivational Minute'}
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col md={12} className="p-0">
            <Tab.Content className="">
              <Tab.Pane eventKey={'Yesterday'}>
                <Yesterday />
              </Tab.Pane>
              <Tab.Pane eventKey={'Today'}>
                <Today />
              </Tab.Pane>
              <Tab.Pane eventKey={'Tomorrow'}>
                <Tomorrow />
              </Tab.Pane>
              <Tab.Pane eventKey={'Motivational-Minute'}>
                <MotivationalMinute />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Tab.Container>
      </Col>
    </Row>
  )
}

export default MorningHuddle
